import { Component, OnInit } from '@angular/core';
import { TranslateService } from '../../shared/translate/services/translate.service';
import { ThemeService } from './theme/theme.service';

@Component({
  selector: 'inc-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {

  selectedLanguage: string;

  constructor(private translateService: TranslateService, private themeService: ThemeService) { }

  ngOnInit() {
    this.selectedLanguage = this.translateService.selectedLanguage;
  }

  changeLanguage(event: any): void {
    this.selectedLanguage = event.detail.value;
    this.translateService.use(this.selectedLanguage);
  }

  onThemeChange(event) {
    if (event && event.detail) {
      event.detail.checked ? this.themeService.enableDark() : this.themeService.enableLight();
    }
  }

}
